import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';

import useClickOutside from '@hooks/useClickOutside';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getSuppliersDetails } from '@store/reducers';
import { fetchSupplierDetails } from '@store/supplier/action';

import { onUpdateSupplierQty } from '@services/supplierService';

import { changeDateFormat, validateNumber } from '@utils/Util';

const EditRelation = ({ onClose }) => {
	const supplierDetails = useSelector(getSuppliersDetails);
	const [supplierInfo, setSupplierInfo] = useState(supplierDetails);
	const [isInfoCLick, setIsInfoClick] = useState(null);
	const dispatch = useDispatch();
	const { id } = useParams();
	const sampleSingleBoxRef = useRef();

	useEffect(() => {
		setSupplierInfo({
			...supplierDetails,
			garmentsDailyQty: '',
			fabricDailyQty: ''
		});
	}, [supplierDetails]);

	const onOutSideClick = () => {
		setIsInfoClick(null);
	};
	useClickOutside(sampleSingleBoxRef, onOutSideClick);

	const updateSupplierQty = async (supplierType, developmentType, value) => {
		try {
			if (!value) return;
			dispatch(openLoader());
			const response = await onUpdateSupplierQty({ id, supplierType, developmentType, value });
			if (response) {
				dispatch(fetchSupplierDetails(id));
			}
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const renderInfo = (total, dataList) => {
		return (
			<div ref={sampleSingleBoxRef} className="sample-single-box">
				<span className="d-flex justify-content-between mb-2">
					<p className="regular-12 gray_dark_01">Commitment</p>
					<p className="regular-12 green">{total} pcs</p>
				</span>
				<p className="regular-12 gray_dark_01 mb-2">Received:</p>
				{dataList?.map((item) => (
					<span className="d-flex justify-content-between mb-2" key={item?.id}>
						<p className="regular-12 gray_dark_02">
							{changeDateFormat(item?.productionDate, '', 'DD Mo, YY')}
						</p>
						<p className="regular-12 gray_dark_01">{item?.quantity} pcs</p>
					</span>
				))}
			</div>
		);
	};

	return (
		<ModalContainer>
			<div className="common-popup relation-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Relation with Nitex</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						{supplierInfo?.supplierTypeList?.includes('GARMENTS') && (
							<>
								<div className="col-md-12">
									<div className="sample-title mb-3 mt-3">
										<div className="sample-click">
											<h3 className="semibold-16 mb-0">
												Garments sample
												<button
													onClick={() => setIsInfoClick('GARMENT')}
													className="border-0 outline-0 bg-transparent ml-2"
												>
													<img
														width="20px"
														src={`${process.env.PUBLIC_URL}/icons/info.svg`}
														alt="sm"
													/>
												</button>
											</h3>
											{isInfoCLick === 'GARMENT' &&
												renderInfo(
													supplierInfo?.garmentsTargetQty,
													supplierInfo?.garmentsDevelopmentQuantity
												)}
										</div>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">Commitment</label>
										<input
											type="number"
											// disabled={!supplierInfo?.supplierTypeList?.includes('GARMENTS')}
											value={supplierInfo?.garmentsTargetQty || null}
											onChange={(e) =>
												setSupplierInfo({
													...supplierInfo,
													garmentsTargetQty: e.target.value
												})
											}
											onBlur={() =>
												updateSupplierQty(
													'GARMENTS',
													'target',
													supplierInfo?.garmentsTargetQty
												)
											}
											onKeyPress={(e) => {
												if (e.key === 'Enter') {
													updateSupplierQty(
														'GARMENTS',
														'target',
														supplierInfo?.garmentsTargetQty
													);
												} else {
													validateNumber(e);
												}
											}}
										/>
									</div>
								</div>
								<div className="col-md-4 pr-2">
									<div className="form-group">
										<label htmlFor="collection">Received</label>
										<input
											className="w-100"
											// disabled={!supplierInfo?.supplierTypeList?.includes('GARMENTS')}
											type="number"
											value={supplierInfo?.garmentsDailyQty || ''}
											onChange={(e) =>
												setSupplierInfo({
													...supplierInfo,
													garmentsDailyQty: e.target.value
												})
											}
											onBlur={() =>
												updateSupplierQty(
													'GARMENTS',
													'quantity',
													supplierInfo?.garmentsDailyQty
												)
											}
											onKeyPress={(e) => {
												if (e.key === 'Enter') {
													updateSupplierQty(
														'GARMENTS',
														'quantity',
														supplierInfo?.garmentsDailyQty
													);
												} else {
													validateNumber(e);
												}
											}}
										/>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">Balance</label>
										<span className="mt-2 d-block">
											{isNaN(Number(supplierInfo?.garmentsTargetQty)) ||
											isNaN(Number(supplierInfo?.garmentsSampleDevelopmentQty))
												? 'N/A'
												: `${
														Number(supplierInfo?.garmentsTargetQty) -
														Number(supplierInfo?.garmentsSampleDevelopmentQty)
													} pcs`}
										</span>
									</div>
								</div>
								<span className="pl-3">
									Total Received: {supplierInfo?.garmentsSampleDevelopmentQty}
								</span>
							</>
						)}

						{supplierInfo?.supplierTypeList?.includes('FABRIC') && (
							<>
								<div className="col-md-12 mt-3">
									<div className="sample-title mb-3 mt-3">
										<div className="sample-click">
											<h3 className="semibold-16 mb-0">
												Fabric sample
												<button
													onClick={() => setIsInfoClick('FABRIC')}
													className="border-0 outline-0 bg-transparent ml-2"
												>
													<img
														width="20px"
														src={`${process.env.PUBLIC_URL}/icons/info.svg`}
														alt="sm"
													/>
												</button>
											</h3>

											{isInfoCLick === 'FABRIC' &&
												renderInfo(
													supplierInfo?.fabricTargetQty,
													supplierInfo?.fabricDevelopmentQuantity
												)}
										</div>
									</div>
								</div>

								<div className="col-md-4 pr-2">
									<div className="form-group">
										<label htmlFor="collection">Commitment</label>
										<input
											className="w-100"
											// disabled={!supplierInfo?.supplierTypeList?.includes('FABRIC')}
											type="number"
											value={supplierInfo?.fabricTargetQty}
											onChange={(e) =>
												setSupplierInfo({
													...supplierInfo,
													fabricTargetQty: e.target.value
												})
											}
											onBlur={() =>
												updateSupplierQty(
													'FABRIC',
													'target',
													supplierInfo?.fabricTargetQty
												)
											}
											onKeyPress={(e) => {
												if (e.key === 'Enter') {
													updateSupplierQty(
														'FABRIC',
														'target',
														supplierInfo?.fabricTargetQty
													);
												} else {
													validateNumber(e);
												}
											}}
										/>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">Received</label>
										<input
											className="w-100"
											// disabled={!supplierInfo?.supplierTypeList?.includes('FABRIC')}
											type="number"
											value={supplierInfo?.fabricDailyQty || ''}
											onChange={(e) =>
												setSupplierInfo({
													...supplierInfo,
													fabricDailyQty: e.target.value
												})
											}
											onBlur={() =>
												updateSupplierQty(
													'FABRIC',
													'quantity',
													supplierInfo?.fabricDailyQty
												)
											}
											onKeyPress={(e) => {
												if (e.key === 'Enter') {
													updateSupplierQty(
														'FABRIC',
														'quantity',
														supplierInfo?.fabricDailyQty
													);
												} else {
													validateNumber(e);
												}
											}}
										/>
									</div>
								</div>
								<div className="col-md-4">
									<div className="form-group">
										<label htmlFor="collection">Balance</label>

										<span className="mt-2 d-block">
											{isNaN(Number(supplierInfo?.fabricTargetQty)) ||
											isNaN(Number(supplierInfo?.fabricSampleDevelopmentQty))
												? ''
												: `${
														Number(supplierInfo?.fabricTargetQty) -
														Number(supplierInfo?.fabricSampleDevelopmentQty)
													} kg`}
										</span>
									</div>
								</div>
								<span className="pl-3">
									Total Received: {supplierInfo?.fabricSampleDevelopmentQty}
								</span>
							</>
						)}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default EditRelation;
